import { CHIZIK_BUSINESS_UNIT, PEREKRESTOK_BUSINESS_UNIT, PYATEROCHKA_BUSINESS_UNIT } from 'shared/config';
import { Retailer } from './types';

export const businessUnitByRetailerName: Record<Retailer, string> = {
  chizhik: CHIZIK_BUSINESS_UNIT,
  perekrestok: PEREKRESTOK_BUSINESS_UNIT,
  pyaterochka: PYATEROCHKA_BUSINESS_UNIT,
};
